export default __webpack_public_path__ + "static/media/caret.ba5861be.svg";